import { StringSchema } from 'yup';

function atLeastOneSimbol(this: StringSchema, message: string) {
  return this.test('atLeastOneSimbol', message, (value) =>
    /_|[^\w]/.test(value)
  );
}

export default atLeastOneSimbol;
